import type { AllRouteEndpoints } from "../routeTypes";
export const usersSubscriptionGroupsIdCacheKeys: AllRouteEndpoints[] = [
  "/users/subscription_groups_data",
  "/users/subscription_group_data",
];
